import { Alert, Box, Typography } from "@mui/material";
import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import { useWorkspaceStore } from "../../../../store/workspace/WorkspaceStore";
import { SAMConfig, SOMConfig } from "../../../../types/workspace";

interface ICPCopyBannerProps {
  /** SAM data to copy */
  sam?: Partial<SAMConfig>;
  /** SOM data to copy */
  som?: Partial<SOMConfig>;
}

/**
 * Compact line banner component that allows copying ICP SAM/SOM data to workspace configuration
 * Designed to be displayed below tabs with full width
 */
export const ICPCopyBanner: FC<ICPCopyBannerProps> = ({ sam, som }) => {
  const { id: workspaceId } = useParams();
  const clearIcpBannerFlags = useWorkspaceStore(
    (state) => state.clearIcpBannerFlags
  );

  const hasData = sam || som;

  if (!hasData) {
    return null;
  }

  const handleLinkClick = () => {
    clearIcpBannerFlags();
  };

  return (
    <Alert
      variant="standard"
      severity="info"
      sx={{
        width: "100%",
        margin: 0,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        borderRadius: 0,
        padding: "0 20px",
        background: "#e5f6fd",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body2" fontWeight={600}>
            Customer Profile Data Updated
          </Typography>
          <Typography variant="body2">
            Would you like to use this analysis to define your SAM and SOM
            within your market definition?
          </Typography>
        </Box>
        <Link
          to={`/projects/${workspaceId}/configuration`}
          style={{ textDecoration: "none" }}
          onClick={handleLinkClick}
        >
          <Typography variant="body2" textTransform="none" color="primary">
            go to project configuration
          </Typography>
        </Link>
      </Box>
    </Alert>
  );
};
